import React, {FC} from 'react'
import { Grid, Segment, Input } from 'semantic-ui-react'
import { createSelector } from 'reselect'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
import { constants as DCConstants } from '../../DetailsContainer'

import { AccountsProps, AccountData } from '../types.LoanDetails'

const filterData = createSelector(
  (data: AccountData[], filter: string) => (!filter ? data : data.filter((x) => x.AccOper.toLowerCase().includes(filter))),
  (result) => result,
)

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_accounts',
  },

  getContextMenuItems: () => ['excelExport'],

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,
  enableRowSelection: true,
  enableSorting: true,

  columnConfigs: {
    AccCreBalCodeIDT: {
      cellStyle: { textAlign: 'right' },
    },

    AccDebBalCodeIDT: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

const Accounts: FC<AccountsProps> = ({ ID, data }) => {
  const [filter, setFilter] = React.useState('')

  const filteredData = filterData(data, filter)

  const instanceName = `${DCConstants.DetailsGridPrefixes.loan}-${ID}-Accounts`

  return (
    <SegmentGroup>
      <Segment.Group>
        <FlexTableChild>
          <TableContainer>
            <LKGrid instanceName={instanceName} rowData={filteredData} {...config} />
          </TableContainer>
        </FlexTableChild>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={5}>
                  <Input
                    onChange={(_event: React.ChangeEvent<HTMLInputElement>, { value }: {value: string}) => {
                      setFilter(value)
                    }}
                    value={filter}
                    fluid
                  />
                </Grid.Column>

                <Grid.Column width={7} floated="right" textAlign="right">
                  <LKGridExportButton alias="export" instanceName={instanceName} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </Segment.Group>
    </SegmentGroup>
  )
}

export default Accounts
